import React from 'react';

import { DateRangeFilter, LabelMultiSelectFilter, SubmitFilter } from './Filters/';
import Content from './General/Content';
import Filters from './General/Filters';
import NewsTable from './InterestTables/NewsTable';

import { MAX_AMOUNT_SELECTED, NEWS_FILTER } from '../../Constants/Interest/Filter';
import { Filter } from '../../Enum/Filters';
import useGetFilterValue from '../../Hook/Interest/UseGetFilterValue';

const News: React.FC = () => {
    const selectedLabels = useGetFilterValue(Filter.NewsLabels) as string[];

    return (
        <div className="interest-content-wrapper" data-testid="change-per-label">
            <Filters filterTotals={{
                amountSelected: selectedLabels.length,
                maxAmountSelected: MAX_AMOUNT_SELECTED
            }}>
                <SubmitFilter filterProperties={NEWS_FILTER} allowEmptyArray />
                <hr />
                <LabelMultiSelectFilter
                    label="Filter op product"
                    placeholder="Productnaam"
                    filterType={Filter.NewsLabels}
                    showExistingCustomers={true}
                    maxAmountSelectedLabels={MAX_AMOUNT_SELECTED}
                />
                <hr />
                <DateRangeFilter />
            </Filters>
            <Content>
                <NewsTable />
            </Content>
        </div>
    );
}

export default News;
